import { HiringFTEPearlFields } from "@oysterhr/hiring/full-time-employee"
import { DailyResponsibilitiesPearlContent } from "./DailyResponsibilitiesPearlContent"
import { PrimaryDutyPearlContent } from "./PrimaryDutyPearlContent"
import { DecisionMakingAuthorityPearlContent } from "./DecisionMakingAuthorityPearlContent"

interface JobDescriptionSubsectionsAdvisorProps {
  focusedField: HiringFTEPearlFields
}
export const JOB_DESCRIPTION_SUBSECTIONS_FIELDS: HiringFTEPearlFields[] = [
  "dailyResponsibilities",
  "primaryDuty",
  "decisionMakingAuthority",
]

export const JobDescriptionSubsectionsAdvisor = ({
  focusedField,
}: JobDescriptionSubsectionsAdvisorProps) => {
  switch (focusedField) {
    case "dailyResponsibilities":
      return <DailyResponsibilitiesPearlContent />
    case "primaryDuty":
      return <PrimaryDutyPearlContent />
    case "decisionMakingAuthority":
      return <DecisionMakingAuthorityPearlContent />
    default:
      return null
  }
}
